export enum ApprovalStatus {
    APPROVED_PREFERRED = 'Approved (Preferred)',
    APPROVED = 'Approved',
    APPROVED_WITH_CONDITIONS = 'Approved with Conditions',
    RETIRING_SEEK_ALTERNATIVE = 'Retiring (Seek Alternative)',
    NOT_APPROVED_FOR_USE = 'Not Approved for Use'
}